import { css } from 'styled-components';
import { company } from './config';
import furusethLogoSmall from './assets/img/furuseth/slakteweb-icon@2x.png';
import furusethLogoLarge from './assets/img/furuseth/slakteweb-logo@2x.png';
import furusethLogoSmallWhite from './assets/img/furuseth/slakteweb-icon-white@2x.png';
import midtnorgeLogoSmall from './assets/img/midtnorge/slakteweb-icon@2x.png';
import midtnorgeLogoLarge from './assets/img/midtnorge/slakteweb-logo@2x.svg';
import midtnorgeLogoLargeWhite from './assets/img/midtnorge/slakteweb-logo-white@2x.svg';
import midtnorgeLogoSmallWhite from './assets/img/midtnorge/slakteweb-icon-white@2x.png';
import midtnorgeLogobSmallIcon from './assets/img/midtnorge/slakteweb-small-icon.png';
import midtnorgeLoginBg from './assets/img/midtnorge/loginPageBg.jpg';
import midtnorgeSlaktewebTxtLogoWhite from './assets/img/midtnorge/slakteweb-tekst-logo.svg';
import midtnorgeSlaktewebTxtLogoBlue from './assets/img/midtnorge/slakteweb-tekst-logo-blaa.svg';

const images = {
  furuseth: {
    slaktewebLogoSmall: furusethLogoSmall,
    slaktewebLogoBig: furusethLogoLarge,
    confirmProfileInfoLogo: furusethLogoLarge,
    confirmProfileInfoLogoMobile: furusethLogoLarge,
    slaktewebLogoSmallWhite: furusethLogoSmallWhite,
    menuLogoMenuOpen: furusethLogoSmallWhite,
    menuLogoMenuOpenMobile: furusethLogoSmallWhite,
    menuLogoMenuClosed: furusethLogoSmall,
    loginPageBg: null,
    slaktewebTxtLogoWhite: null,
    loadingImage: furusethLogoSmall,
    menuLogoMenuClosedMobile: furusethLogoSmall,
  },
  midtnorge: {
    slaktewebLogoSmall: midtnorgeLogoSmall,
    slaktewebLogoBig: midtnorgeLogoLarge,
    slaktewebLogoSmallWhite: midtnorgeLogoSmallWhite,
    loginPageBg: midtnorgeLoginBg,
    confirmProfileInfoLogo: midtnorgeSlaktewebTxtLogoWhite,
    confirmProfileInfoLogoMobile: midtnorgeSlaktewebTxtLogoBlue,
    menuLogoMenuOpen: midtnorgeLogobSmallIcon,
    menuLogoMenuOpenMobile: midtnorgeLogobSmallIcon,
    menuLogoMenuClosed: midtnorgeLogobSmallIcon,
    menuLogoMenuClosedMobile: midtnorgeLogobSmallIcon,
    slaktewebTxtLogoWhite: midtnorgeSlaktewebTxtLogoWhite,
    loadingImage: midtnorgeLogoLargeWhite,
    slaktewebTxtLogoBlue: midtnorgeSlaktewebTxtLogoBlue,
  },
};

export const imageTypes = {
  slaktewebLogoSmall: 'slaktewebLogoSmall',
  slaktewebLogoBig: 'slaktewebLogoBig',
  slaktewebLogoSmallWhite: 'slaktewebLogoSmallWhite',
  loginPageBg: 'loginPageBg',
  menuLogoMenuOpen: 'menuLogoMenuOpen',
  menuLogoMenuClosed: 'menuLogoMenuClosed',
  slaktewebTxtLogoWhite: 'slaktewebTxtLogoWhite',
  confirmProfileInfoLogo: 'confirmProfileInfoLogo',
  menuLogoMenuClosedMobile: 'menuLogoMenuClosedMobile',
  menuLogoMenuOpenMobile: 'menuLogoMenuOpenMobile',
  slaktewebTxtLogoBlue: 'slaktewebTxtLogoBlue',
  confirmProfileInfoLogoMobile: 'confirmProfileInfoLogoMobile',
};

const texts = {
  furuseth: {
    companyName: 'Furuseth',
  },
  midtnorge: {
    companyName: 'Midt-Norge Slakteri',
  },
};

const contactInformation = {
  furuseth: {
    loginSupportEmail: 'regnskap@furuseth.no',
    loginSupportPhone: '63 97 70 10',
    registerUserWithoutEmailadressEmail: 'regnskap@furuseth.no',
    errorLoadingEnrolmentPageContactPhone: '63 97 70 10',
  },
  midtnorge: {
    loginSupportEmail: 'postmottak@norsk-slakt.no',
    loginSupportPhone: '74 08 37 00',
    registerUserWithoutEmailadressEmail: 'postmottak@norsk-slakt.no',
    errorLoadingEnrolmentPageContactPhone:
      '74 08 37 00 (Åpningstid 8-16) eller send e-post til postmottak@norsk-slakt.no',
  },
};

const links = {
  furuseth: {
    registerEnrolmentInfo: 'https://www.furuseth.no/innmelding',
    marksOnReturnInfo: 'https://furuseth.no/innmelding',
  },
  midtnorge: {
    registerEnrolmentInfo: '',
    marksOnReturnInfo: '',
  },
};

const colors = {
  furuseth: {
    primary: '#0b479e',
    fontSecondary: '#6e6d6d',
    fontHeader: '#686A6E',
    fontLight: '#ffffff',
    fontNormal: '#4f4f4f',
    link: '#0B479E',

    linkPrimary: '#0B479E',
    linkSecondary: '#444447',
    linkPrimaryHover: '#0a3778',

    cellBorder: '#eaebed',
    good: '#417505',
    warn: '#f33535',
    fieldIcon: '#777777',
    oddBackground: '#fefefe',
    mainBg: 'white',
    altBg: '#1952a4',
    whiteBg: '#ffffff',
    whiteAltBg: '#f4f1ec',
    error: '#d0021b',
    primaryBtn: '#0247b0',
    primaryBtnFont: 'white',
    primaryBtnHover: '#003fa0',
    primaryBtnFocus: '#003b94',
    primaryBtnActive: '#003789',
    primaryBtnDisabled: 'gray',
    secondaryBackground: ' #EEEFED',
    secondaryBtn: 'white',
    secondaryBtnFont: '#0B479E',
    secondaryBtnBorder: '#0050ca',
    secondaryBtnHoverBorder: '#00378c',
    secondaryBtnFocus: '#727272',
    secondaryBtnActive: '#5c5c5c',
    secondaryBtnDisabled: 'gray',
    loadingIndicatorTxt: '#18479b',
    infoBubbleBorder: '#919191',
    loginFormBg: 'rgba(255, 255, 255, 0.9)',
    balanceBg: '#f7f6f5',
    iconNotificationCount: '#c20000',
    statisticsTableHeaderCellBg: '#f0f6fc',
    statisticsTableHeaderCellColor: 'inherit',
    statisticsGeneralStatsData: '#0b479e',
    statisticsHoverTableRowBg: 'whitesmoke',
    statisticsTableBorder: '#ccc',
    statisticsToggleExpandGeneralStatsBorder: '#0b479e',
    statisticsToggleExpandGeneralStats: '#0b479e',
    statisticsGraphFarmerGroup: '#64a5e7',
    statisticsGraphFarmerGroupTwo: '#e3d1cf',
    statisticsGraphSlaughterhouseGroup: '#2f49a3',
    statisticsGraphSlaughterhouseGroupTwo: '#8a8888',
  },
  midtnorge: {
    primary: '#034088',
    mnRed: '#e2051b',
    mnBlue: '#034088',
    fontSecondary: '#6e6d6d',
    fontHeader: '#686A6E',
    fontLight: '#ffffff',
    fontNormal: '#4f4f4f',
    link: '#0B479E',

    linkPrimary: '#034088',
    linkSecondary: '#444447',
    linkPrimaryHover: '#0a3778',
    loginPageHeader: 'white',

    cellBorder: '#eaebed',
    good: '#417505',
    warn: '#cc1517',
    fieldIcon: '#777777',
    oddBackground: '#fefefe',
    mainBg: 'white',
    altBg: '#1952a4',
    whiteBg: '#ffffff',
    whiteAltBg: '#f4f1ec',
    error: '#cc1517',
    primaryBtn: '#034088',
    primaryBtnFont: 'white',
    primaryBtnHover: '#013471',
    primaryBtnFocus: '#003b94',
    primaryBtnActive: '#003789',
    primaryBtnDisabled: 'gray',
    secondaryBackground: '#f1f1f1',
    secondaryBtn: 'white',
    secondaryBtnFont: '#034088',
    secondaryBtnBorder: '#084eb9',
    secondaryBtnHoverBorder: '#00378c',
    secondaryBtnFocus: '#727272',
    secondaryBtnActive: '#5c5c5c',
    secondaryBtnDisabled: 'gray',
    loadingIndicatorTxt: '#18479b',
    infoBubbleBorder: 'infoBubbleBorder',
    iconNotificationCount: '#e2051b',

    balanceBg: '#f1f1f1',
    loginFormBg: 'white',
    statisticsTableHeaderCellBg: '#034088',
    statisticsTableHeaderCellColor: 'white',
    statisticsGeneralStatsData: '#034088',
    statisticsHoverTableRowBg: '#f1f1f1',
    statisticsTableBorder: 'lightgrey',
    statisticsToggleExpandGeneralStatsBorder: '#034088',
    statisticsToggleExpandGeneralStats: '#034088',
    statisticsGraphFarmerGroup: '#64a5e7',
    statisticsGraphFarmerGroupTwo: '#e3d1cf',
    statisticsGraphSlaughterhouseGroup: '#2f49a3',
    statisticsGraphSlaughterhouseGroupTwo: '#8a8888',
  },
};

export const colorTypes = {
  primary: 'primary',
  fontSecondary: 'fontSecondary',
  fontHeader: 'fontHeader',
  fontLight: 'fontLight',
  fontNormal: 'fontNormal',
  link: 'link',

  linkPrimary: 'linkPrimary',
  linkSecondary: 'linkSecondary',
  linkPrimaryHover: 'linkPrimaryHover',
  linkDisabled: 'linkDisabled',

  cellBorder: 'cellBorder',
  good: 'good',
  warn: 'warn',
  fieldIcon: 'fieldIcon',
  oddBackground: 'oddBackground',
  mainBg: 'mainBg',
  altBg: 'altBg',
  whiteBg: 'whiteBg',
  whiteAltBg: 'whiteAltBg',
  error: 'error',
  primaryBtn: 'primaryBtn',
  primaryBtnFont: 'primaryBtnFont',
  primaryBtnHover: 'primaryBtnHover',
  primaryBtnFocus: 'primaryBtnFocus',
  primaryBtnActive: 'primaryBtnActive',
  primaryBtnDisabled: 'primaryBtnDisabled',
  secondaryBackground: 'secondaryBackground',
  secondaryBtn: 'secondaryBtn',
  secondaryBtnFont: 'secondaryBtnFont',
  secondaryBtnBorder: 'secondaryBtnBorder',
  secondaryBtnHoverBorder: 'secondaryBtnHoverBorder',
  secondaryBtnFocus: 'secondaryBtnFocus',
  secondaryBtnActive: 'secondaryBtnActive',
  secondaryBtnDisabled: 'secondaryBtnDisabled',
  loadingIndicatorTxt: 'loadingIndicatorTxt',
  infoBubbleBorder: '#919191',
  loginFormBg: 'loginFormBg',
  balanceBg: 'balanceBg',
  iconNotificationCount: 'iconNotificationCount',
  statisticsTableHeaderBg: 'statisticsTableHeaderBg',
  statisticsGeneralStatsData: 'statisticsGeneralStatsData',
  statisticsHoverTableRowBg: 'statisticsHoverTableRowBg',
  statisticsTableHeaderCellColor: 'statisticsTableHeaderCellColor',
  statisticsTableHeaderCellBg: 'statisticsTableHeaderCellBg',
  statisticsTableBorder: 'statisticsTableBorder',
  statisticsToggleExpandGeneralStatsBorder:
    'statisticsToggleExpandGeneralStatsBorder',
  statisticsToggleExpandGeneralStats: 'statisticsToggleExpandGeneralStats',
  statisticsGraphFarmerGroup: 'statisticsGraphFarmerGroup',
  statisticsGraphSlaughterhouseGroup: 'statisticsGraphSlaughterhouseGroup',
};

export const textTypes = {
  companyName: 'companyName',
};
export const contactInformationTypes = {
  loginSupportEmail: 'loginSupportEmail',
  loginSupportPhone: 'loginSupportPhone',
  registerUserWithoutEmailadressEmail: 'registerUserWithoutEmailadressEmail',
  errorLoadingEnrolmentPageContactPhone:
    'errorLoadingEnrolmentPageContactPhone',
};

export const linkTypes = {
  registerEnrolmentInfo: 'registerEnrolmentInfo',
  marksOnReturnInfo: 'marksOnReturnInfo',
};

const stylesheets = {
  furuseth: 'furuseth.scss',
  midtnorge: 'midtnorge.scss',
};

export const getBrandingImage = (img) => images[company][img];
export const getBrandingText = (txt) => texts[company][txt];
export const getBrandingContactInformation = (info) => contactInformation[company][info];
export const getBrandingLinks = (name) => links[company][name];

export const getBrandingColor = (name) => colors[company][name];

export const getBrandingStylesheet = () => stylesheets[company];

export const getIsFontSizeIsHeader = (size, name = '') => {
  if (company === 'midtnorge') {
    if (['statisticsSelectedFilter'].indexOf(name) >= 0) {
      return false;
    }
    return (
      size
      && ((size.match('[0-9]*(.)[0-9]*em') && size.split('em')[0] >= 1.5)
        || (size.match('[0-9]*(.)[0-9]*px') && size.split('px')[0] > 22))
    );
  } else if (company === 'furuseth') {
    return false;
  }
};

const brandingStyleOverrides = {
  midtnorge: {
    topMenuNotLoggedIn: css`
      border-bottom: 4.5px solid ${colors.midtnorge.mnRed};
      background-color: ${colors.midtnorge.mnBlue};
      height: 4em;
    `,
    topMenuLoggedIn: css`
      border-bottom: 4.5px solid ${colors.midtnorge.mnRed};
      background-color: white;
      height: 4em;
    `,
    boldText: css`
      font-family: Open Sans, sans-serif;
      font-weight: 600;
    `,
    balanceTxt: css`
      font-family: Open Sans, sans-serif;
      font-weight: 600;
    `,
    menuLogo: css`
    `,
    menuLogoMobile: css`
    `,
    headerText: css`
      font-family: "Open Sans Light", sans-serif;
      font-weight: 300;
      color: black;
    `,
    page: css`
      margin-top: 0;
      padding-top: 2em;
    `,
    text: css`
      font-family: Open Sans Regular, sans-serif;
    `,

    topMenuTabletMobileSize: css`
      [name="profile"] {
        order: 1;
      }
      [name="messages"] {
        order: 2;
      }
      [name="superuser-impersonate"] {
        order: 4;
      }
      [name="superuser-resetpassword"] {
        order: 5;
      }
      [name="openclose"] {
        order: 6;
      }
    `,
    topMenu: css`
      [name="logo"] {
        position: relative;
        left: 10%;
        margin-left: 0;
        transform: translateX(-25%);
        width: 100px;
        max-width: 65px;
        height: auto;
        align-self: center;
      }
    `,
    statisticsPeriodType: css`
      font-family: "Open Sans", sans-serif;
      position: relative;
      bottom: 1px;
      font-weight: 600;
    `,
    dashboardTabletMobileSize: css`
      [name="balanceTxt"] {
        font-size: 2.08em;
      }
    `,
    menuRow: css`
      height: 4em; 
    `,
    loginPage: css`
      img.mobile{
        display: none;
      }
      .login-page-header{
        color: white;
      }
    `,

    errorLoadingEnrolmentPageContactInfo: css`
      width: 80%;
      margin-left: 1em;
    `,
    confirmProfileInfoPageMobile: css`
       .logo{
         position: relative;
         margin-left: 0;
         left: calc(50% - 1.2em);
         transform: translateX(-50%);
       }
    `,
    loginPageMobile: css`
      background : white;
      .login-page-header{
        color: black;
      }
      background-image: none; 
      img.desktop-tablet{
        display: none;
      }
      img.mobile{
        display: block;
        margin-bottom: 0.25em;
      }
    `,

    statisticsSelectedFilter: css`
      margin-bottom: 2px;
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        margin-bottom: 4px;
      }
    `,
    statisticsTableDiseseNameHeader: css`
      border-right-color: #034088;
    `,
  },
  furuseth: {
    menuLogo: css`
      flex-basis: auto;
    `,
  }
};

export const styleOverrides = {
  topMenuLoggedIn: 'topMenuLoggedIn',
  boldText: 'boldText',
  semiboldText: 'semiboldText',
  headerText: 'headerText',
  balanceTxt: 'balanceTxt',
  menuLogo: 'menuLogo',
  topMenuTabletMobileSize: 'topMenuTabletMobileSize',
  dashboardTabletMobileSize: 'dashboardTabletMobileSize',
  page: 'page',
  text: 'text',
  statisticsPeriodType: 'statisticsPeriodType',
  errorLoadingEnrolmentPageContactInfo: 'errorLoadingEnrolmentPageContactInfo',
  statisticsSelectedFilter: 'statisticsSelectedFilter',
  statisticsTableDiseseNameHeader: 'statisticsTableDiseseNameHeader',
  menuLogoMobile: 'menuLogoMobile',
};

export const getBrandingStyleOverride = (key) => (
  (brandingStyleOverrides[company] && brandingStyleOverrides[company][key])
    || ''
);
